import React, { useRef, useState } from 'react';
import { FaFilePdf, FaFileAlt } from 'react-icons/fa';
import tick from '../../../../../../assets/image/tick.svg';
import deletei from '../../../../../../assets/image/delete.svg';
import eye from '../../../../../../assets/image/eye.svg';
import { toast } from 'react-toastify';
import ConfirmationModal from '../../../../../../component/modal/ConfirmationModal';
import ViewDocs from '../../../../../vendors/VenUploadDocument/ViewDocs';
import { getCurrentDate, getDate } from '../../../../../../utils/dateUtils';
import { getLocalStorageData } from '../../../../../../utils/helper';
import { axiosInstanceV2 } from '../../../../../../services/axios';
import { APP_API_URL_V2 } from '../../../../../../utils/xhr-instance';
import { deleteCustomerDocuments } from '../../../../../../services/customers';

const CustomerDocuments = ({
	setCustomerDocs,
	customerDocs,
	customerId,
	customerType,
	prescriptionsDocsList,
	setPrescriptionsDocsList,
}) => {
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const [currentDocType, setCurrentDocType] = useState('');
	const [selectedFile, setSelectedFile] = useState(null);
	const [dragging, setDragging] = useState(false);
	const [isUploadingFile, setIsUploadingFile] = useState(false);
	const [isDeleteDocModalOpen, setIsDeleteDocModalOpen] = useState(false);
	const [deleteDocDetails, setDeleteDocDetails] = useState(null);
	const [docId, setDocId] = useState(null);
	const fileInputRef = useRef(null);
	const acceptedFileTypes = ['pdf', 'png', 'jpeg', 'jpg'];

	const openPopup = (docType) => {
		setCurrentDocType(docType);
		setSelectedFile(null);
		setIsPopupOpen(true);
	};

	const closePopup = () => setIsPopupOpen(false);

	const handleDragOver = (e) => {
		e.preventDefault();
		setDragging(true);
	};

	const handleDragLeave = (e) => {
		e.preventDefault();
		setDragging(false);
	};

	const handleDrop = (e) => {
		e.preventDefault();
		setDragging(false);
		const file = e.dataTransfer.files[0];
		if (file) {
			const extension = file.name.split('.').pop().toLowerCase();
			if (acceptedFileTypes.includes(extension)) {
				setSelectedFile(file);
			} else {
				alert('This file type is not accepted. Please upload a PDF, PNG, JPEG, or JPG file.');
			}
		}
	};

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			const extension = file.name.split('.').pop().toLowerCase();
			if (acceptedFileTypes.includes(extension)) {
				setSelectedFile(file);
			} else {
				toast.error('This file type is not accepted. Please upload a PDF, PNG, JPEG, or JPG file.');
			}
		}
	};

	const handleSetNullFile = (docName, index = -1) => {
		if (docName === 'prescription_doc') {
			var prescriptionList;
			if (docId !== null) {
				prescriptionList = prescriptionsDocsList.filter((data) => data.id !== docId);
			} else {
				prescriptionList = prescriptionsDocsList.filter((_, i) => i !== index);
			}
			setPrescriptionsDocsList(prescriptionList);
		}
		if (docName === 'gst_doc') {
			setCustomerDocs((prev) => ({
				...prev,
				gstDocs: null,
			}));
		}

		if (docName === 'drug_license_doc') {
			setCustomerDocs((prev) => ({
				...prev,
				drugLicenseDocs: null,
			}));
		}

		if (docName === 'pan_doc') {
			setCustomerDocs((prev) => ({
				...prev,
				panDocs: null,
			}));
		}

		if (docName === 'aadhar_card_doc') {
			setCustomerDocs((prev) => ({
				...prev,
				adhaarDocs: null,
			}));
		}

		if (docName === 'fssai_doc') {
			setCustomerDocs((prev) => ({
				...prev,
				fssaiDocs: null,
			}));
		}
		setDocId(null);
		setSelectedFile(null);
		setCurrentDocType('');
	};

	const handleUpload = async (setDocs, docName) => {
		try {
			if ((customerId === null || customerId === undefined) && selectedFile) {
				if (docName === 'gst_doc') {
					setCustomerDocs((prev) => ({
						...prev,
						gstDocs: selectedFile,
					}));
				}
				if (docName === 'prescription_doc') {
					const data = { uploaded_at: getCurrentDate(), imagePath: selectedFile };
					var prescriptionsList = [...prescriptionsDocsList, data];
					setPrescriptionsDocsList(prescriptionsList);
				}

				if (docName === 'drug_license_doc') {
					setCustomerDocs((prev) => ({
						...prev,
						drugLicenseDocs: selectedFile,
					}));
				}

				if (docName === 'pan_doc') {
					setCustomerDocs((prev) => ({
						...prev,
						panDocs: selectedFile,
					}));
				}

				if (docName === 'aadhar_card_doc') {
					setCustomerDocs((prev) => ({
						...prev,
						adhaarDocs: selectedFile,
					}));
				}

				if (docName === 'fssai_doc') {
					setCustomerDocs((prev) => ({
						...prev,
						fssaiDocs: selectedFile,
					}));
				}
			}

			if (customerId === undefined) {
				closePopup();
				return;
			}

			if (selectedFile) {
				setIsUploadingFile(true);
				const token = getLocalStorageData();
				const formData = new FormData();
				formData.append(docName, selectedFile);
				formData.append('customer_id', customerId);

				try {
					var data;
					if (docName === 'prescription_doc' || docId === null) {
						data = await axiosInstanceV2.post(
							`${APP_API_URL_V2}/customer/upload/documents`,
							formData,
							{
								headers: {
									'Content-Type': 'multipart/form-data',
									Authorization: `Bearer ${token?.token}`,
								},
							},
						);
					} else {
						data = await axiosInstanceV2.put(
							`${APP_API_URL_V2}/customer/${customerId}/documents/${docId}`,
							formData,
							{
								headers: {
									'Content-Type': 'multipart/form-data',
									Authorization: `Bearer ${token?.token}`,
								},
							},
						);
					}

					setDocId(null);
					if (data?.data?.success) {
						var document = data?.data?.data?.customer?.documents;
						if (docName === 'prescription_doc') {
							var list = [...prescriptionsDocsList, ...document];
							setPrescriptionsDocsList(list);
						}
						if (Array.isArray(document)) {
							document = document[0];
						}
						if (docName === 'gst_doc') {
							setCustomerDocs((prev) => ({
								...prev,
								gstDocs: document,
							}));
						}

						if (docName === 'drug_license_doc') {
							setCustomerDocs((prev) => ({
								...prev,
								drugLicenseDocs: document,
							}));
						}

						if (docName === 'pan_doc') {
							setCustomerDocs((prev) => ({
								...prev,
								panDocs: document,
							}));
						}

						if (docName === 'aadhar_card_doc') {
							setCustomerDocs((prev) => ({
								...prev,
								adhaarDocs: document,
							}));
						}

						if (docName === 'fssai_doc') {
							setCustomerDocs((prev) => ({
								...prev,
								fssaiDocs: document,
							}));
						}

						toast.success('Document upload successfully!');
						closePopup();
					}
				} catch (error) {
					throw new Error('Fail to upload document!');
				}
			} else {
				throw new Error('Please select a document to upload!');
			}
		} catch (error) {
			toast.error(error.message);
		} finally {
			setIsUploadingFile(false);
		}
	};

	const handleDeleteFile = async () => {
		try {
			await deleteCustomerDocuments(customerId, docId);
			handleSetNullFile(deleteDocDetails);
			toast.success('Document deleted successfully.');
		} catch (error) {
			toast.error('Document Delete failed! Try again.');
		} finally {
			setDeleteDocDetails(null);
			setIsDeleteDocModalOpen(false);
		}
	};

	const renderUploadSection = (docType, docData, setDocs) => {
		const docName = docType.split('_').join(' ').toUpperCase();
		return (
			<div className="accordion-item">
				<h2
					className="accordion-header"
					id={`heading${docType}`}
				>
					<button
						className="accordion-button collapsed"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target={`#collapse${docType}`}
						aria-expanded="false"
						aria-controls={`collapse${docType}`}
					>
						<span>{docName} </span>
						<span>
							{(docData && docData?.length > 0 && docType === 'prescription_doc') ||
							(docType !== 'prescription_doc' && docData) ? (
								<img
									src={tick}
									alt="Uploaded"
								/>
							) : (
								''
							)}
						</span>
					</button>
				</h2>
				<div
					id={`collapse${docType}`}
					className="accordion-collapse collapse"
					aria-labelledby={`heading${docType}`}
				>
					{(docData && docData?.length > 0 && docType === 'prescription_doc') ||
					(docData && docType !== 'prescription_doc') ? (
						<table>
							<thead>
								<tr>
									<th style={{ textAlign: 'left' }}>DATE UPLOADED</th>
									<th style={{ textAlign: 'left' }}>DOCUMENT NAME</th>
									<th>STATUS</th>
									<th>ACTIONS</th>
								</tr>
							</thead>
							<tbody>
								{docType === 'prescription_doc' ? (
									docData.map((data, index) => {
										return (
											<tr>
												<td style={{ textAlign: 'left' }}>{getDate(data.uploaded_at)}</td>
												<td style={{ textAlign: 'left' }}>
													<ViewDocs
														vendorId={customerId}
														docName={docType}
														docData={
															data.imagePath !== null && data.imagePath !== undefined
																? data.imagePath
																: data.name
														}
													/>
												</td>
												<td>
													<span className="status-icon">
														<img
															src={tick}
															alt="Uploaded"
														/>
													</span>
												</td>
												<td>
													<div
														style={{
															display: 'flex',
															gap: 20,
															alignItems: 'center',
															justifyContent: 'center',
														}}
													>
														<div className="view-icon">
															<a
																href={
																	data.imagePath instanceof File
																		? URL.createObjectURL(data.imagePath)
																		: data.url
																}
																target="_blank"
																rel="noreferrer"
															>
																<img
																	src={eye}
																	alt="View"
																	style={{ cursor: 'pointer' }}
																/>
															</a>
														</div>
														<div
															className="delete-icon"
															style={{ cursor: 'pointer' }}
															onClick={() => {
																if (customerId) {
																	setDeleteDocDetails(docType);
																	setIsDeleteDocModalOpen(true);
																	setDocId(data.id);
																} else {
																	setDocId(null);
																	handleSetNullFile(docType, index);
																}
															}}
														>
															<img
																src={deletei}
																alt="Delete"
															/>
														</div>
													</div>
												</td>
											</tr>
										);
									})
								) : (
									<tr>
										<td style={{ textAlign: 'left' }}>
											{docData.uploaded_at !== null && docData.uploaded_at !== undefined
												? getDate(docData.uploaded_at)
												: getCurrentDate()}
										</td>
										<td style={{ textAlign: 'left' }}>
											<ViewDocs
												vendorId={customerId}
												docName={docType}
												docData={
													docData.id !== null && docData.id !== undefined ? docData.name : docData
												}
											/>
										</td>
										<td>
											<span className="status-icon">
												<img
													src={tick}
													alt="Uploaded"
												/>
											</span>
										</td>
										<td>
											<div
												style={{
													display: 'flex',
													gap: 20,
													alignItems: 'center',
													justifyContent: 'center',
												}}
											>
												<div className="view-icon">
													<a
														href={
															docData instanceof File ? URL.createObjectURL(docData) : docData.url
														}
														target="_blank"
														rel="noreferrer"
													>
														<img
															src={eye}
															alt="View"
															style={{ cursor: 'pointer' }}
														/>
													</a>
												</div>
												<div
													className="delete-icon"
													style={{ cursor: 'pointer' }}
													onClick={() => {
														if (customerId) {
															setDeleteDocDetails(docType);
															setIsDeleteDocModalOpen(true);
															setDocId(docData.id);
														} else {
															setDocId(null);
															handleSetNullFile(docType);
														}
													}}
												>
													<img
														src={deletei}
														alt="Delete"
													/>
												</div>
											</div>
										</td>
									</tr>
								)}
							</tbody>
						</table>
					) : (
						''
					)}
					<div className="accordion-body">
						<div className={docData ? 'document-areaForColor' : 'document-area'}>
							<button
								onClick={() => {
									openPopup(docType);
									if (docData && docType !== 'prescription_doc' && customerId) {
										setDocId(docData.id);
									}
								}}
								className="DocUploadBtn"
							>
								{docType === 'prescription_doc'
									? 'Upload New Documents'
									: docData && docType !== 'prescription_doc'
										? 'Re-upload Document'
										: 'Upload Document'}
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	};

	const getFileIcon = (fileName) => {
		const extension = fileName.split('.').pop().toLowerCase();
		const iconStyle = {
			width: '70px',
			height: '70px',
			border: '1px dashed rgba(85, 91, 103, 0.30)',
			borderRadius: '10px',
			backgroundColor: '#FCFCFC',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		};

		return (
			<div style={iconStyle}>
				{extension === 'pdf' ? <FaFilePdf size={40} /> : <FaFileAlt size={40} />}
			</div>
		);
	};

	return (
		<div className="vendor-upload-document">
			<div
				className="accordion"
				id="accordionExample"
			>
				{customerType === 0 &&
					renderUploadSection('prescription_doc', prescriptionsDocsList, 'setPrescriptions')}
				{customerType === 1 && renderUploadSection('gst_doc', customerDocs.gstDocs, 'setGstDoc')}
				{customerType === 1 &&
					renderUploadSection(
						'drug_license_doc',
						customerDocs.drugLicenseDocs,
						'setDrugLicanceDocs',
					)}
				{renderUploadSection('pan_doc', customerDocs.panDocs, 'setPanDocs')}
				{renderUploadSection('aadhar_card_doc', customerDocs.adhaarDocs, 'setAdharCardDocs')}
				{customerType === 1 &&
					renderUploadSection('fssai_doc', customerDocs.fssaiDocs, 'setFassaiDoc')}
			</div>

			{isPopupOpen && (
				<div className={`popup ${dragging ? 'dragging' : ''}`}>
					<div
						className="popup-content"
						onDragOver={handleDragOver}
						onDragLeave={handleDragLeave}
						onDrop={handleDrop}
					>
						<h2 className="PopHeading">Upload {currentDocType.replace('_', ' ').toUpperCase()}</h2>
						<br />
						{!selectedFile ? (
							<div className={`DropfileDesign ${dragging ? 'drag-over' : ''}`}>
								<div
									className="Browse"
									style={{ cursor: 'pointer' }}
									onClick={(event) => {
										if (event.target !== fileInputRef.current && event.target.tagName !== 'LABEL') {
											fileInputRef.current.click();
										}
									}}
								>
									<label
										style={{ cursor: 'pointer' }}
										htmlFor="file-upload"
										className="custom-file-upload"
									>
										Browse..
									</label>
									<input
										id="file-upload"
										type="file"
										ref={fileInputRef}
										onChange={handleFileChange}
										style={{ display: 'none' }}
									/>
								</div>
								<div>or drop file here</div>
							</div>
						) : (
							<div className="selected-file-area">
								<div className="selected-file-display d-flex justify-content-center align-items-center">
									<div
										style={{ width: '250px' }}
										className="d-flex align-items-center"
									>
										{getFileIcon(selectedFile.name)}
										<div
											className="d-flex align-items-center"
											style={{ paddingLeft: '10px' }}
										>
											<p style={{ marginRight: '30px' }}>
												{selectedFile.name} <br />
												<span style={{ fontSize: '12px', color: 'gray' }}>
													{(selectedFile.size / 1024).toFixed(2)} kb
												</span>
											</p>
										</div>
									</div>
									<div>
										<img
											src={deletei}
											alt="Delete"
											className="delete-file-icon"
											onClick={() => setSelectedFile(null)}
											style={{ cursor: 'pointer', marginLeft: '10px' }}
										/>
									</div>
								</div>
							</div>
						)}
						<br />
						<div className="button-group">
							<button
								className="CancelBtn"
								onClick={closePopup}
							>
								Cancel
							</button>
							<button
								className="UploadBtn"
								onClick={() => handleUpload('', currentDocType)}
								disabled={!selectedFile || isUploadingFile}
							>
								{isUploadingFile ? 'Uploading...' : 'Upload'}
							</button>
						</div>
					</div>
				</div>
			)}

			{isDeleteDocModalOpen && (
				<ConfirmationModal
					isOpen={isDeleteDocModalOpen}
					title="Delete Document"
					content={
						<p
							style={{
								textAlign: 'center',
								backgroundColor: '#E6F5FF',
								padding: '10px',
								borderRadius: '5px',
								fontWeight: '500',
								color: 'black',
							}}
						>
							Are you sure You want to delete {deleteDocDetails?.split('_').join(' ').toUpperCase()}{' '}
							file ?
						</p>
					}
					onCancel={() => {
						setIsDeleteDocModalOpen(false);
						setDeleteDocDetails(null);
						setDocId(null);
					}}
					onOk={handleDeleteFile}
				/>
			)}
		</div>
	);
};

export default CustomerDocuments;
